<template>

 <div id="contact-form" class="contact-form">
	<button id="hideContact" type="close"  @click="Hide" class="button" >x</button>
<img alt="Vue logo" src="../assets/logo.png" width="100px" height="100px">
		<p>If you are experiencing problems with this website, please send us a note refererencing the browser that you're using, and any problems you're experiencing.</p>
		<p>If you identify a missing  or a poorly formatted map; please send us a note referencing the municipality and tax map number, and the issue with the map.</p>
		<p>* Please note that issues with specific map content must be addressed to/by the Municipal Tax Assessor.</p>
		<br>
		<h1 class="contact-form_title">Contact Form</h1>
		<div class="separator"></div>

		<div v-if="isSending" class="loading">Sending...</div>

		<form class="form" id="contactus" @submit="Submit" method="post">
			<input required name="name" v-model='from.name' placeholder="Name" type="text" autocomplete="off">
			<input required name="email" v-model="from.email" placeholder="E-mail" type="email" autocomplete="off">
			<textarea required name="message" v-model="content.value" rows="6" placeholder="Message"></textarea>
			<button type="submit"  value="Submit" class="button" >Send</button>
		</form>
	</div> 
	
</template>

<script>
/* ///////stu commented this section out 12/27/2021
import axios from "axios";
*/
export default {
    apikey:'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',
  name: 'ContactUs',
  props: {
    msg: String
  },
  data () {
    return {
   //  personalizations:[],   
	tos:[{name: 'Morris County GIS', email: 'mcgis@co.morris.nj.us'},
			{name: 'srice', email: 'srice@co.morris.nj.us'}
		]
         ,
    from: {email: '', name:''},
    subject:'Tax Map Viewer',
    content:{type:'text/plain',
    value:''},
    isSending: false
    }

  },




 computed: {
   
   
 
},
mounted() {
}, 


methods:{
		/**
		 * Clear the form
		*/	
	clearForm() {
			this.personalizations = [];
			this.value = '';
	},
	
	Hide: function(){
		
		this.$modal.hide('ContactUs');
	},
	Submit: function(evt) {
			evt.preventDefault();

			this.isSending = true;
			this.clearForm() 
			setTimeout(() => {
				// https://sendgrid.com/docs/api-reference/
				// Build request body for sendgridapi
                // let form = new FormData();
                
                let message = new Object();
                message.tos = this.tos;
                message.from = this.from;
                message.subject = this.subject;
                message.content = this.content;
               // this.personalizations.push(message);


/*		////////// stu commented this section out 12/27/2021	
				var url = 'https://morrisgisapps.co.morris.nj.us/serverApps/sendGridEmail/api/mail';
				
				var config = {headers: { 'authorization' : 'Bearer ' + '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',
										'content-type':'application/json'
										}
							};	

					axios.post(url,message,config).then(
					(response) => {
						
						}, 
					(error) => {
						console.log(error)
						}
					)
*/

				this.isSending = false;
				this.clearForm() 
				alert('Message sent.')
				this.$modal.hide('ContactUs');
			}, 1000);
		}

}





}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
	z-index: 10;
	background: #f1f1f1;
	font-family: 'Roboto', sans-serif;
	

}
img{text-align: center;
margin-top: 10px;
margin-left: 250px;}
p{
	margin:20px 3px;
}
.contact-form {
	font-family: 16px;
	margin: 0 auto;
	max-width: 600px;
	width: 100%;
	background-color: rgb(236, 237, 243);
}

.contact-form .separator {
	border-bottom: solid 1px #ccc;
	margin-bottom: 15px;
}

.contact-form .form {
	display: flex;
	flex-direction: column;
	font-size: 16px;
}

.contact-form_title {
	color: #333;
	text-align: left;
	font-size: 28px;
	margin-left:3px;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea {
	border: solid 1px #e8e8e8;
	font-family: 'Roboto', sans-serif;
	padding: 10px 7px;
	margin-bottom: 15px;
	margin-left: 3px;
	margin-right:3px;
	outline: none;
}

.contact-form textarea {
	resize: none;
}

.contact-form .button {
	background: hsl(219, 65%, 18%);
	border: solid 1px hsl(219, 65%, 18%);
	height:40px;
	margin:3px;
	color: white;
	cursor: pointer;
	padding: 10px 50px;
	text-align: center;
	text-transform: uppercase;
}

.contact-form .button:hover {
	background:hsl(219, 55%, 30%);
	border: solid 1pxhsl(219, 55%, 30%);
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
	font-size: 15px;
	border-radius: 3px
}
#hideContact{
	position: absolute;
  top:0;
  right:0;
  width:30px;
   height:30px;
   padding-top:0;
   padding-left:0;
    padding-right:0;
background: hsl(7, 89%, 30%);	
	border: solid 1px hsl(7, 89%, 30%);	
font-size: 28px;
	border-radius: 0

}
</style>